import { FC } from 'react';
import BordOneToneIcon from '../../../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import BordPhoto from '../../../../../../../components/NudosComponents/BordPhoto/BordPhoto';
import { AGENT_CHAT_FILTER_OPTIONS } from '../../../../../../../types/agentChat.types';
import './AgentChatEmptyState.scss';

/**
 * Componente que muestra el estado inicial del chat cuando no hay preguntas
 * Muestra sugerencias de preguntas comunes para ayudar al usuario
 */
const AgentChatEmptyState: FC<AgentChatEmptyStateProps> = ({ handleSendMessage }) => {
  const suggestions = [
    { question: '¿Qué órdenes están actualmente fuera del SLA?', option: AGENT_CHAT_FILTER_OPTIONS.DEFAULT },
    { question: '¿Qué servicios están actualmente fuera del SLA?', option: AGENT_CHAT_FILTER_OPTIONS.DEFAULT },
    {
      question: '¿Qué órdenes o servicios vencerán su SLA en los próximos 2 días?',
      option: AGENT_CHAT_FILTER_OPTIONS.DEFAULT
    }
  ];

  const handleSuggestionClick = (suggestion: { question: string; option: AGENT_CHAT_FILTER_OPTIONS }) => {
    handleSendMessage(suggestion.question, suggestion.option);
  };

  return (
    <div className="agentChatEmptyState">
      <div className="emptyStateContainer">
        <BordPhoto size="s56" avatarProps={{ variant: 'circularBordMascot' }} className="logoImage" />
        <div className="titleText">¿Tienes una duda? Pregúntale a Bordi</div>
        <div className="subtitleText">Este asistente te ayuda a obtener información clave en segundos</div>

        <div className="suggestionGrid">
          {suggestions.map((suggestion, index) => (
            <div key={index} className="suggestionCard" onClick={() => handleSuggestionClick(suggestion)}>
              <p className="suggestionText">{suggestion.question}</p>
              <BordOneToneIcon variant="arrowRight" customWidth="20px" className="arrowIcon" stroke="#383838" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

interface AgentChatEmptyStateProps {
  handleSendMessage: (question: string, option: AGENT_CHAT_FILTER_OPTIONS) => void;
}

export default AgentChatEmptyState;
